/* Licence counts on /administration — gate 15. Counts only: nothing here is a control, a price or
   a limit, and the stylesheet has no class for any of them. Tokens only (ADR-0007). */

.rows {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 6px;
}

.row {
  display: grid;
  grid-template-columns: minmax(0, 13rem) minmax(0, 1fr);
  gap: 2px 14px;
  align-items: baseline;
  font-size: var(--t-dense);
}

.label {
  color: var(--ink-2);
}

.count {
  font-variant-numeric: lining-nums tabular-nums;
  font-weight: 650;
  color: var(--ink);
}

.total {
  padding-top: 6px;
  border-top: 1px solid var(--line);
}

.group {
  margin: 0 0 6px;
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--muted);
}

.groups {
  display: grid;
  gap: 16px;
}

/* What a licence would be counted on: a plain list of three sentences, not a control. */
.measures {
  margin: 0;
  padding-left: 1.1em;
  display: grid;
  gap: 4px;
  font-size: var(--t-dense);
  color: var(--ink-2);
}
